/** Rotating copy for makeup loaders — no "AI" wording. */

export const RECOMMEND_LOADER_MESSAGES = [
  'Reading your skin tone and undertone…',
  'Mapping cheeks, eyes, and lip shape…',
  'Matching looks to your depth band…',
  'Balancing blush and lip harmonies…',
  'Shortlisting your best presets…',
];

export const RECOMMEND_LOADER_DONE = 'Your personalised picks are ready';

export const RECOMMEND_LOADER_TITLE = 'Finding your looks';

export const APPLY_LOADER_TITLE = 'Beauty Enhancement';

export const APPLY_LOADER_DONE = 'Your look is ready';

export const APPLY_PHASE_MESSAGES = {
  prepare: 'Opening your capture…',
  landmarks: 'Mapping facial features…',
  foundation: 'Blending foundation and concealer…',
  colour: 'Adding blush, lips, and eye colour…',
  process: 'Rendering your full look…',
  eyes: 'Defining liner and lashes…',
  finish: 'Perfecting the final finish…',
};

export function recommendMessageForProgress(progress) {
  const p = Math.max(0, Math.min(100, Math.round(Number(progress) || 0)));
  if (p >= 100) return RECOMMEND_LOADER_DONE;
  if (p >= 82) return RECOMMEND_LOADER_MESSAGES[4];
  if (p >= 62) return RECOMMEND_LOADER_MESSAGES[3];
  if (p >= 42) return RECOMMEND_LOADER_MESSAGES[2];
  if (p >= 22) return RECOMMEND_LOADER_MESSAGES[1];
  return RECOMMEND_LOADER_MESSAGES[0];
}

export function applyMessageForProgress(progress) {
  const p = Math.max(0, Math.min(100, Math.round(Number(progress) || 0)));
  if (p >= 100) return APPLY_LOADER_DONE;
  if (p >= 90) return APPLY_PHASE_MESSAGES.finish;
  if (p >= 72) return APPLY_PHASE_MESSAGES.eyes;
  if (p >= 54) return APPLY_PHASE_MESSAGES.process;
  if (p >= 38) return APPLY_PHASE_MESSAGES.colour;
  if (p >= 22) return APPLY_PHASE_MESSAGES.foundation;
  if (p >= 10) return APPLY_PHASE_MESSAGES.landmarks;
  return APPLY_PHASE_MESSAGES.prepare;
}

export function setRecommendLoaderStep(setProgress, setMessage, progress) {
  const p = Math.max(0, Math.min(100, Math.round(progress)));
  setProgress(p);
  setMessage(recommendMessageForProgress(p));
}

export function setApplyLoaderStep(setProgress, setMessage, progress) {
  const p = Math.max(0, Math.min(100, Math.round(progress)));
  setProgress(p);
  setMessage(applyMessageForProgress(p));
}

export function delayMs(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

/** Hold at 100% briefly so the bar completes before the overlay closes. */
export async function finishLoaderUi(setProgress, setMessage, doneMessage) {
  setProgress(100);
  if (doneMessage) setMessage(doneMessage);
  await delayMs(480);
}
